import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

//todo add disabled as variant, if needed
const CText = ({ cVariant, cText }) => {
  let tColor = "inherit", tFontWeight = "inherit";
  if (cVariant === "header_card") {
    tColor = "white";
    cVariant = "h6";
    return (
      <Box
        bgcolor="secondary.main"
        p={2}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          margin: '1em 0'
        }}
      >
        <Typography variant={cVariant} color={tColor} fontWeight="bold">
          {cText}
        </Typography>
      </Box>
    );
  } else if (cVariant === "no_data") {
    tColor = "#888888";
    cVariant = "h6";
    if (cText === undefined) {
      cText = "No Data";
    }
    return (
      <Box
        bgcolor="#F2F2F2"
        p={2}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
          margin: '1em 0'
        }}
      >
        <Typography variant={cVariant} color={tColor} fontWeight="bold">
          {cText}
        </Typography>
      </Box>
    );
  } else if (cVariant === "head_card") {
    tColor = "secondary";
    tFontWeight = "bold"
    cVariant = "subtitle1";
  } else if (cVariant === "title_card") {
    //tColor = "secondary";
    tFontWeight = "bold"
    cVariant = "subtitle1";
  } else if (cVariant === "heading_section") {
    cVariant = "h6";
  }

  return (
    <Typography variant={cVariant} color={tColor} fontWeight={tFontWeight}>
      {cText}
    </Typography>
  );
};

export default CText;